
import { useState } from "react";
import { Play } from "../../../../assets/icons";
import DetailAccentCard, {
	DetailSectionHeading,
} from "../../../common/detail/DetailAccentCard";

export default function InfoSection({ workshop }) {
	const [isPlaying, setIsPlaying] = useState(false);

	const hasIntroVideo = Boolean(workshop.intro_video && workshop.intro_video_url);

	if (!hasIntroVideo) {
		return null;
	}

	return (
		<DetailAccentCard ariaLabel="ویدیوی معرفی" bodyClassName="p-5 md:p-6">
			<DetailSectionHeading className="mb-4">
				ویدیوی معرفی
			</DetailSectionHeading>

			{isPlaying ? (
				<div className="overflow-hidden rounded-[12px] bg-black ring-1 ring-darkBlue/15">
					<video
						className="w-full max-h-[70vh]"
						controls
						controlsList="nodownload"
						autoPlay
					>
						<source src={workshop.intro_video_url} type="video/mp4" />
					</video>
				</div>
			) : (
				<button
					type="button"
					className={[
						"flex w-full items-center justify-center gap-2 rounded-[12px]",
						"border border-darkBlue/15 bg-gradient-to-l from-lightCta to-white py-4",
						"font-Vazir-600 text-[14px] text-darkBlue cursor-pointer",
						"transition hover:border-cta/40 hover:text-cta",
					].join(" ")}
					onClick={() => setIsPlaying(true)}
				>
					<Play width={14} height={15} />
					پخش ویدیوی معرفی
				</button>
			)}
		</DetailAccentCard>
	);
}
